import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { FixedAsset, FixedAssetCreate, FixedAssetFilter } from '../data/fixedAsset';

export function createFixedAssetService(client: AxiosInstance) {
  return createCrudService<FixedAsset, FixedAssetCreate, FixedAssetFilter>(
    client,
    '/asset-management/FixedAsset',
    'id',
  );
}

export type FixedAssetService = CrudService<FixedAsset, FixedAssetCreate, FixedAssetFilter>;
